function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Label } from './elements';
import Bullet from './Bullet';
/**
 * A CheckBox depicts a binary state if used alone, just as a ToggleButton, the difference being
 * that ToggleButton triggers the callback with the new state value, whereas the CheckBox
 * just triggers the callback without any argument so the parent needs to keep track by itself.
 *
 * @return {jsx}
 */

var CheckBox = /*#__PURE__*/function (_PureComponent) {
  _inherits(CheckBox, _PureComponent);

  var _super = _createSuper(CheckBox);

  function CheckBox() {
    var _this;

    _classCallCheck(this, CheckBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isChecked: _this.props.isDefaultChecked // eslint-disable-line

    });

    _defineProperty(_assertThisInitialized(_this), "isControlled", function (prop) {
      var props = _this.props;
      return props.hasOwnProperty(prop);
    });

    _defineProperty(_assertThisInitialized(_this), "getControllableValue", function (key) {
      var props = _this.props;
      var state = _this.state;
      return _this.isControlled(key) ? props[key] : state[key];
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          isDisabled = _this$props.isDisabled;

      if (isDisabled) {
        return;
      }

      var isChecked = _this.getControllableValue('isChecked');

      if (_this.isControlled('isChecked')) {
        onChange && onChange(!isChecked);
      } else {
        event.persist();

        _this.setState({
          isChecked: !isChecked
        }, function () {
          onChange && onChange(event);
        });
      }
    });

    return _this;
  }

  _createClass(CheckBox, [{
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          isDisabled = _this$props2.isDisabled,
          value = _this$props2.value;
      var isChecked = this.getControllableValue('isChecked');
      return /*#__PURE__*/React.createElement(Wrapper, {
        className: className,
        "data-testid": "checkBox"
      }, /*#__PURE__*/React.createElement(Label, {
        isDisabled: isDisabled,
        isChecked: isChecked,
        "data-testid": "checkBox-label"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        "data-testid": "hidden-checkBox",
        defaultChecked: isChecked,
        disabled: isDisabled,
        onChange: this.handleChange,
        tabIndex: isDisabled ? -1 : 0,
        value: value
      }), /*#__PURE__*/React.createElement(Bullet, {
        isChecked: isChecked
      }), children));
    }
  }]);

  return CheckBox;
}(PureComponent);

CheckBox.Bullet = Bullet;
/** Prop types. */

CheckBox.propTypes = {
  /**
   * Anything that can be rendered: numbers, strings, elements or an array (or fragment)
   */
  children: PropTypes.node,

  /**
   * ClassName needed by styled components
   */
  className: PropTypes.string,

  /**
   * Specifies whether the checkbox is checked by default
   */
  isDefaultChecked: PropTypes.bool,

  /**
   * Specifies whether the checkbox is checked
   */
  // eslint-disable-next-line react/no-unused-prop-types
  isChecked: PropTypes.bool,

  /**
   * Specifies whether the checkbox is disabled
   */
  isDisabled: PropTypes.bool,

  /**
   * Callback triggered on CheckBox state change
   */
  onChange: PropTypes.func,

  /**
   * The value to be used in the checkbox input. This is the value that will be returned on form submission.
   */
  value: PropTypes.node
};
/** Default props. */

CheckBox.defaultProps = {
  children: null,
  className: '',
  isDefaultChecked: false,
  isDisabled: false,
  onChange: null,
  value: ''
};
export default CheckBox;